import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 306px;
  height: auto;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  position: relative;
  background: ${({ background }) => (background ? background : "#fff")};
  box-shadow: 0px 4px 10px 0px #0000000a;

  .upper-card {
    display: flex;
    align-items: flex-start;
  }

  .image-and-data {
    display: flex;
    gap: 10px;
  }

  .image-wrapper {
    min-width: 87px;
    max-width: 87px;
    height: 90px;
    /* border-radius: 10px 10px 0px 0px; */
    overflow: hidden;
    position: relative;
    display: flex;

    & .ant-image {
      width: 100%;
      height: 100%;
      overflow: hidden;
      /* border-radius: 4px; */
      background: #fff;
      & .ant-image-mask {
        border-radius: 11px 11px 0px 0px;
      }

      & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .data-wrapper {
    display: flex;
    flex-direction: column;
  }

  .member-name {
    width: 100%;
    color: #0c0a64;

    font-size: 16px;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .member-position {
    font-weight: 500;
    font-size: 15px;
    width: 100%;
    color: #8490a5;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Qatordan soni */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .dotsWrap {
    display: flex;
    justify-content: flex-end;
    border: none;
    outline: none;
    position: absolute;
    background: none;
    top: 10px;
    right: 10px;

    & .three-dots {
      cursor: pointer;
      color: #8490a5;
      font-size: 20px;
    }
  }

  .desc {
    font-size: 15px;
    color: #8490a5;
    padding-top: 16px;
    font-weight: 500;
    line-height: 16px;
  }
  .more {
    color: #0038ff;
    line-height: 16px;
  }
`;

export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 1;
  width: 100px;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  color: #343c6a;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: var(--sidebar-item-active);
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: red;
  }
`;
